import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_ROUTES } from './api-routes';
import { InviteUserResponse, User, UserSettings } from '../interfaces/user-interfaces';
import { Observable } from 'rxjs';
import { DEFAULT_FORMDATA_HEADERS, DEFAULT_JSON_HEADERS } from './headers.config';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  constructor(private http: HttpClient) { }

  getUserData(): Observable<any> {
    const payload = {
    };

    return this.http.get<User>(
      API_ROUTES.USER.ME,
      payload
    );
  }

  updateUserSettings(id: string, newSettings: UserSettings): Observable<any> {
    const payload = JSON.stringify(newSettings);

    return this.http.post<User>(
      `${API_ROUTES.USER.SETTINGS_ID}${id}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  uploadImage(image: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", image);

    return this.http.post<User>(
      API_ROUTES.USER.UPLOAD_IMAGE,
      formData,
    );
  }

  updateUser(newUserData: User): Observable<any> {
    const payload = JSON.stringify(newUserData);

    return this.http.patch<User>(
      `${API_ROUTES.USER.ME}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  createInviteLink(email: string, assigned_role: string): Observable<any> {
    const payload = {
      email: email,
      assigned_role: assigned_role
    };

    return this.http.post<InviteUserResponse>(
      `${API_ROUTES.USER.INVITE_LINK}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  getInviteLinkData(id: string): Observable<any> {
    return this.http.get<InviteUserResponse>(
      `${API_ROUTES.USER.INVITE_LINK_ID}${id}`,
    );
  }

  deleteAccount(): Observable<any> {
    const payload = {
    };

    return this.http.post<any>(
      `${API_ROUTES.USER.DELETE_REQUEST}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }

  cancelDeleteAccount(): Observable<any> {
    const payload = {
    };

    return this.http.post<any>(
      `${API_ROUTES.USER.DELETE_CANCEL}`,
      payload,
      { headers: DEFAULT_JSON_HEADERS }
    );
  }
}
